import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-location-bl.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-location-bl.component.scss?ngResource";
import { ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { ViewApplicationBaseComponent } from "../../../shared/view-application-base/view-application-base.component";
import { ApplicationViewService } from "../../../shared/application-view.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { AppControllerService } from "../../../../app-controller.service";
import { MapService } from "../../../../map/shared/map.service";
import { RouterParamsService } from "../../../../shared/services/route-params.service";
import { WktConverterUtils } from "../../../../shared/utils/wkt-converter-utils";
import * as JsonUtils from "@arcgis/core/geometry/support/jsonUtils";
import { ApiProxyConstants } from "../../../../shared/constants/api-constants/api-proxy.constants";
import { AppConfig } from "../../../../app.config";
import { AppRoutingConstants } from "../../../../app-routing.constants";
import { UrlConstants } from "../../../../shared/constants/url.constants";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { ViewApplicationLocationBlConstants } from "./view-application-location-bl.constants";
import { AutoUnsubPortal } from "../../../../shared/decorators/autounsub-portal.decorator";
import { take } from "rxjs/operators";
let ViewApplicationLocationBlComponent = class ViewApplicationLocationBlComponent extends ViewApplicationBaseComponent {
    applicationViewService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appController;
    mapService;
    changeDetectorRefs;
    routerParamsService;
    active;
    propertiesForm;
    descriptionLabel1 = ViewApplicationLocationBlConstants.DESCRIPTION_LABEL_1;
    descriptionLabel2 = ViewApplicationLocationBlConstants.DESCRIPTION_LABEL_2;
    descriptionLabel3 = ViewApplicationLocationBlConstants.DESCRIPTION_LABEL_3;
    validationMessages = ViewApplicationLocationBlConstants.VALIDATION_MESSAGES;
    erfNoControl = ViewApplicationLocationBlConstants.ERF_NO_CONTROL;
    propertiesFormGroupName = ViewApplicationLocationBlConstants.PROPERTIES_FORM_GROUP_NAME;
    centroidFromControlName = ViewApplicationLocationBlConstants.CENTROID_CONTROL;
    propertiesFormControlName = ViewApplicationLocationBlConstants.PROPERTIES_FORM_CONTROL;
    subdivisionControl = ViewApplicationLocationBlConstants.SUBDIVISION_CONTROL;
    allotmentControl = ViewApplicationLocationBlConstants.ALLOTMENT_CONTROL;
    farmNoControl = ViewApplicationLocationBlConstants.FARM_NO_CONTROL;
    sgCodeControl = ViewApplicationLocationBlConstants.SG_CODE_CONTROL;
    addressControl = ViewApplicationLocationBlConstants.ADDRESS_CONTROL;
    unitNumberControl = ViewApplicationLocationBlConstants.UNIT_NUMBER_CONTROL;
    shopNumberControl = ViewApplicationLocationBlConstants.SHOP_NUMBER_CONTROL;
    titleDeedNumberControl = ViewApplicationLocationBlConstants.TITLE_DEED_NUMBER_CONTROL;
    titleDeedDescriptionNumberControl = ViewApplicationLocationBlConstants.TITLE_DEED_DESCRIPTION_CONTROL;
    erfNoTextPlaceHolder = ViewApplicationLocationBlConstants.ERF_NO_TEXT_PLACEHOLDER;
    subdivisionTextPlaceHolder = ViewApplicationLocationBlConstants.SUBDIVISION_TEXT_PLACEHOLDER;
    allotmentTextPlaceHolder = ViewApplicationLocationBlConstants.ALLOTMENT_TEXT_PLACEHOLDER;
    farmNoTextPlaceHolder = ViewApplicationLocationBlConstants.FARM_NO_TEXT_PLACEHOLDER;
    sgCodeTextPlaceHolder = ViewApplicationLocationBlConstants.SG_CODE_TEXT_PLACEHOLDER;
    addressTextPlaceHolder = ViewApplicationLocationBlConstants.ADDRESS_TEXT_PLACEHOLDER;
    unitNumberPlaceHolder = ViewApplicationLocationBlConstants.UNIT_NUMBER_PLACEHOLDER;
    erfSizeTextPlaceHolder = ViewApplicationLocationBlConstants.ERF_SIZE_TEXT_PLACEHOLDER;
    shopNumberTextPlaceHolder = ViewApplicationLocationBlConstants.SHOP_NUMBER_TEXT_PLACEHOLDER;
    titleDeedNumberTextPlaceHolder = ViewApplicationLocationBlConstants.TITLE_DEED_NUMBER_TEXT_PLACEHOLDER;
    nameOfAccommodationTextPlaceholder = ViewApplicationLocationBlConstants.NAME_OF_ACCOMMODATION_TEXT_PLACEHOLDER;
    nameOfAccommodationControl = ViewApplicationLocationBlConstants.NAME_OF_ACCOMMODATION_CONTROL;
    titleDeedDescriptionTextPlaceHolder = ViewApplicationLocationBlConstants.TITLE_DEED_DESCRIPTION_TEXT_PLACEHOLDER;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    removePropertyLabel = ViewApplicationLocationBlConstants.REMOVE_PROPERTY_LABEL;
    geometryControl = ViewApplicationLocationBlConstants.GEOMETRY_CONTROL;
    applicationLoaded = false;
    subdivisionControlRequired = true;
    farmNoControlRequired = true;
    erfNoControlRequired = true;
    mapComponent;
    application;
    getTrueCentroidSubscription;
    constructor(applicationViewService, aflaModuleStrategyService, selectedApplicationService, appController, mapService, changeDetectorRefs, routerParamsService) {
        super(applicationViewService, aflaModuleStrategyService, selectedApplicationService, routerParamsService);
        this.applicationViewService = applicationViewService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appController = appController;
        this.mapService = mapService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.routerParamsService = routerParamsService;
        this.initForm();
        this.listenForSelectedApplication();
        this.getMetadata();
    }
    initForm() {
        this.propertiesForm = this.aflaModuleStrategyService.form.get(this.propertiesFormGroupName);
    }
    listenForSelectedApplication() {
        this.selectedApplicationService.$selectedApplication.pipe(take(1)).subscribe({
            next: (application) => {
                if (application && application.id >= 0 && !this.applicationLoaded) {
                    this.application = application;
                    this.setApplicationData();
                    this.applicationLoaded = true;
                }
            }
        });
    }
    mapLoaded() {
        this.syncMapGeometries();
    }
    setApplicationData() {
        if (this.application && this.application.properties && this.application.properties.length > 0) {
            if (!this.getProperties()) {
                return;
            }
            else {
                this.getProperties().clear();
                const propertyControl = this.getProperties();
                this.selectedApplication?.properties?.sort((a, b) => (b?.id - a?.id));
                this.application.properties.forEach((property) => {
                    // create form groups for each property
                    const geometryArc = WktConverterUtils.ConvertWktToArcGisJson(property.shape, 102100);
                    const geom = JsonUtils.fromJSON(geometryArc);
                    const newPropertyFormGroup = this.createFormGroup(property, geom);
                    this.setTrueCentroid(geometryArc, newPropertyFormGroup, propertyControl);
                    this.syncMapGeometries();
                });
            }
        }
    }
    syncMapGeometries() {
        const geometries = [];
        this.getProperties().controls.forEach(item => {
            const geom = item.get(this.geometryControl).value;
            if (geom !== null) {
                geometries.push(geom);
            }
        });
        if (geometries.length > 0) {
            this.mapComponent.addGeometriesOnMap(geometries, ViewApplicationLocationBlConstants.LAYER_REF, true);
        }
        this.changeDetectorRefs.markForCheck();
    }
    setTrueCentroid(geometryArc, newPropertyFormGroup, propertyControl) {
        const proxyUrl = ApiProxyConstants.URL;
        const gpToolUrl = AppConfig.settings.arcGIS.servicesURL + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
        const url = `${proxyUrl}?${gpToolUrl}`;
        const formData = new FormData();
        formData.append("f", "json");
        formData.append("geometryJSON", JSON.stringify(geometryArc));
        this.getTrueCentroidSubscription = this.applicationViewService.getTrueCentroid(url, formData).subscribe({
            next: (response) => {
                newPropertyFormGroup.get(this.centroidFromControlName).setValue(response.results[0].value);
                propertyControl.push(newPropertyFormGroup);
                this.active = propertyControl.length - 1;
                this.disablePropertyControls(propertyControl.length - 1);
                this.syncMapGeometries();
                this.changeDetectorRefs.markForCheck();
            },
            error: (error) => {
                this.appController.handleServerErrorMessage(ViewApplicationLocationBlConstants.TRUE_CENTROID, error, CRUDOperation.Get);
            }
        });
    }
    createFormGroup(savedProperty, geom) {
        return new FormGroup({
            id: new FormControl(savedProperty.id),
            erfNo: new FormControl(savedProperty.erfNumber),
            subdivision: new FormControl(savedProperty.subdivision),
            allotment: new FormControl(savedProperty.allotment),
            farmNo: new FormControl(savedProperty.farmNumber),
            sgCode: new FormControl(savedProperty.sgCode),
            address: new FormControl(savedProperty.address),
            geometry: new FormControl(geom),
            unitNumber: new FormControl(savedProperty.unitNumber),
            shopNumber: new FormControl(savedProperty.shopNumber),
            accommodationName: new FormControl(savedProperty.accommodationName),
            titleDeedNumber: new FormControl(savedProperty.titleDeedNumber),
            titleDeedDescription: new FormControl(savedProperty.titleDeedDescription),
            centroid: new FormControl(null)
        });
    }
    disablePropertyControls(propertyIndex) {
        const propertyControl = this.getProperties().controls[propertyIndex];
        propertyControl.get(this.erfNoControl).disable();
        propertyControl.get(this.subdivisionControl).disable();
        propertyControl.get(this.allotmentControl).disable();
        propertyControl.get(this.sgCodeControl).disable();
        propertyControl.get(this.addressControl).disable();
        propertyControl.get(this.farmNoControl).disable();
        propertyControl.get(this.unitNumberControl).disable();
        propertyControl.get(this.shopNumberControl).disable();
        propertyControl.get(this.nameOfAccommodationControl).disable();
        propertyControl.get(this.titleDeedNumberControl).disable();
        propertyControl.get(this.titleDeedDescriptionNumberControl).disable();
    }
    ngAfterViewInit() {
        this.mapService.actionBayEnabled = false;
    }
    getProperties() {
        if (this.propertiesForm) {
            return this.propertiesForm.get(this.propertiesFormControlName);
        }
    }
    handleRouteChange() {
    }
    loadMetadata() {
    }
    static ctorParameters = () => [
        { type: ApplicationViewService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: MapService },
        { type: ChangeDetectorRef },
        { type: RouterParamsService }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }]
    };
};
ViewApplicationLocationBlComponent = __decorate([
    Component({
        selector: "app-view-application-location-bl",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsubPortal()
], ViewApplicationLocationBlComponent);
export { ViewApplicationLocationBlComponent };
